var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98593 7.28995L11.5915 2.68665C11.7866 2.49149 11.9194 2.24289 11.9732 1.97226C12.027 1.70163 11.9994 1.42112 11.8938 1.16619C11.7882 0.911261 11.6094 0.693355 11.38 0.540014C11.1506 0.386673 10.8809 0.30478 10.605 0.304688L1.39499 0.304688C1.11906 0.30478 0.849357 0.386673 0.619961 0.540014C0.390565 0.693355 0.211778 0.911261 0.106197 1.16619C0.000617027 1.42112 -0.0270166 1.70163 0.0267887 1.97226C0.0805941 2.24289 0.213423 2.49149 0.408486 2.68665L5.01407 7.29223C5.276 7.55313 5.63077 7.69943 6.00047 7.69901C6.37018 7.69858 6.7246 7.55146 6.98593 7.28995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.8f815eecfae40c0b458dc7f978ea47f9.svg";
export { ForwardRef as ReactComponent };